import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })

export class CredentialService {

    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {
    }

    guardarCredential(new_credential){
      this.url_final = this.backendUrl + "/rmsfe/create_seller_credential_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {new_credential})
      .pipe(map(response => {
        return response;
      }));
    }
    
    loginDropi(credentials) {
      return this.http.post<any>('https://mf-dropi.tiui.app/v1/auth/login', credentials)
      .pipe(map(response => {
        return response;
      }));
    }
    
    loginTiui(credentials) {
      return this.http.post<any>('https://api.tiui.app/api/AccountTiuiAmigo/login', {
        userName: credentials.email,
        password: credentials.password
      })
      .pipe(map(response => {
        return response;
      }));
    }
    
    getDropiWarehouses(credentials, userId, token) {
      return this.http.get<any>(`https://mf-dropi.tiui.app/v1/orders/warehouse/list/${userId}`, { 
        headers: { 
          Authorization: `${token}`,
          'Content-Type': 'application/json',
          'Anonymous': ''
        },
         params: credentials
      } )
      .pipe(map(response => {
        return response;
      }));
    }
    
    actualizarCredential(credential) {
      this.url_final = this.backendUrl + "/rmsfe/update_seller_credential_api"
      return this.http.post<any>(this.url_final, {credential})
      .pipe(map(response => {
        return response;
      }));
    }
    
    eliminarCredential(credential_id) {
      this.url_final = this.backendUrl + "/rmsfe/delete_seller_credential_api"
      return this.http.post<any>(this.url_final, { 
        params: { credential_id: credential_id } 
      })
      .pipe(map(response => {
        return response;
      }));
    }
}